<template>
    <transition name="fade">
        <div v-if="message"
            class="flex items-center leading-none text-base text-green-warm-600 z-100 px-4 py-3"
        >
            <i class="fa fa-check mb-px mr-1.5 text-xs"></i>{{ message }}
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        message: {},
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
